/* tslint:disable */
var TrackingEventGamePaymentshopClick = /** @class */ (function () {
    function TrackingEventGamePaymentshopClick(args) {
        this.EVENT_ID = 67;
        this.MAPPING_VERSION = 2;
        this.data = args;
        this.data.eventId = this.EVENT_ID;
        this.data.event_mapping_version = this.MAPPING_VERSION;
    }
    return TrackingEventGamePaymentshopClick;
}());
export { TrackingEventGamePaymentshopClick };
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/TrackingEventGamePaymentshopClick.ts
// module id = 1698
// module chunks = 3